"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _conversionService = _interopRequireDefault(require("api/conversionService.js"));
require("./style.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var SiteHealth = /*#__PURE__*/function (_Component) {
  function SiteHealth(props) {
    var _this;
    _classCallCheck(this, SiteHealth);
    _this = _callSuper(this, SiteHealth, [props]);
    _this.state = {
      servicesUpdatedList: [],
      completeService: ''
    };
    _this.getHealth = _this.getHealth.bind(_this);
    _this.servicesList = [{
      key: '["VerificationService"]',
      name: 'Verification Service',
      value: false
    }, {
      key: '["EDPService"]',
      name: 'EDP Service',
      value: false
    }, {
      key: '["UTAdapterService"]',
      name: 'User Token Adapter Service',
      value: false
    }, {
      key: '["userIdentityAdapter"]',
      name: 'User Identity Adapter Service',
      value: false
    }, {
      key: '["UTMService"]',
      name: 'User Token Management Service',
      value: false
    }, {
      key: '["ConversionDBService"]',
      name: 'Conversion DB Service',
      value: false
    }];
    return _this;
  }
  _inherits(SiteHealth, _Component);
  return _createClass(SiteHealth, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getHealth();
    }
  }, {
    key: "getHealth",
    value: function getHealth() {
      var _this2 = this;
      _conversionService["default"].getSiteHealth().then(function (response) {
        var servicesUpdatedList = [];
        response.forEach(function (data) {
          var serviceData = _this2.servicesList.find(function (k) {
            return k.key === JSON.stringify(Object.keys(data));
          });
          if (JSON.stringify(Object.keys(data)) !== JSON.stringify(['service'])) servicesUpdatedList.push({
            key: serviceData ? serviceData.key : Object.keys(data),
            name: serviceData ? serviceData.name : Object.keys(data),
            value: JSON.stringify(Object.values(data))
          });
        });
        _this2.setState({
          servicesUpdatedList: servicesUpdatedList,
          completeService: Object.values(response.find(function (k) {
            return JSON.stringify(Object.keys(k)) === JSON.stringify(["service"]);
          }))
        });
      })["catch"](function (err) {
        _this2.props.history.push('/systemError');
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        servicesUpdatedList = _this$state.servicesUpdatedList,
        completeService = _this$state.completeService;
      var statusDisplay = servicesUpdatedList.map(function (data) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: data.key,
          className: data.value === '["True"]' ? 'iconGreenCheck' : 'icon_invalidCheck'
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "status"
        }, data.name, " ", data.value === '["True"]' ? 'is up and running!' : 'is down!'));
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "align-center"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "tds-h1--article tds-h1--small align-left margin-top-xx-large"
      }, "ePay, Premium Audit and Legacy Risk Control Conversion Health Status"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "tds-small align-left"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: JSON.stringify(completeService) === JSON.stringify(['up']) ? 'serviceUp' : 'serviceDown'
      }, " Service is ", completeService, " "), /*#__PURE__*/_react["default"].createElement("ul", null, " ", statusDisplay, " ")));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = SiteHealth;